import "./BusinessCapital.module.css";
import GlobalHeader from "@/reusable_sections/Header";
import GrowthCapitalMandate from "./sections/GrowthCapitalMandate";
import CapitalInstruments from "./sections/CapitalInstruments";
import FundingRequest from "./sections/FundingRequest";
import InstitutionalFooter from "@/reusable_sections/Footer";
export default function BusinessCapitalPage() {
  return <div>
      <GlobalHeader />
      <GrowthCapitalMandate />
      <CapitalInstruments />
      <FundingRequest />
      <InstitutionalFooter />
    </div>;
}